import { render, staticRenderFns } from "./PlacementBookingTable.vue?vue&type=template&id=72926bc1"
import script from "./PlacementBookingTable.vue?vue&type=script&lang=js"
export * from "./PlacementBookingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports